interface GoogleAdProps {
  type: string;
  [key: string]: any;
}
const shouldRenderAd = (): boolean => {
  // 小米暂时不加广告
  const excludedDomains = [
    "en-wg.comfortweather.com",
    "hi-wg.comfortweather.com",
    "id-wg.comfortweather.com",
    "es-wg.comfortweather.com",
    "en-miwg.comfortweather.com",
    "hi-miwg.comfortweather.com",
    "id-miwg.comfortweather.com",
    "localhost",
    "24hweather.com",
  ];

  return !excludedDomains.includes(window.location.hostname);
};
export default function GoogleAd(props: GoogleAdProps) {
  if (isEmptyType(props)) {
    return null;
  }

  if (!shouldRenderAd()) {
    return null;
  }

  const { type, ...args } = props;
  return type === "ads" ? <Ads {...args} /> : <Adx {...args} />;
}
